import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import reducers from "../reducers";
import { createFirebaseAuthStateListener } from "../actions/Auth";
import { initializeFirebaseApp } from "../actions/Firebase";

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const bindMiddleware = (middleware) => {
  if (process.env.REACT_APP_ENV !== 'production' && process.env.REACT_APP_ENV !== 'staging') {
    const { composeWithDevTools } = require("redux-devtools-extension");
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

function configureStore(initialState = {}) {
  const store = createStore(
    reducers(history),
    initialState,
    bindMiddleware([routeMiddleware, thunk])
  );

  store.dispatch(initializeFirebaseApp());

  store.dispatch(
    createFirebaseAuthStateListener(store.getState().firebase.firebaseAuth)
  );

  return store;
}
export default configureStore;
export { history };
